import React from 'react';
import * as CurrencyUtils from '../../../../../../utils/currency';
import * as DatesUtils from '../../../../../../utils/dates';

export const TableColumns = () => [
  {
    label: 'Member State',
    id: 'country',
    align: 'left',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Total VAT Amount Due',
    id: 'total_amount_due',
    align: 'left',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>
        {CurrencyUtils.formatCurrency(cellValue ?? 0)}
      </React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Total Amount Allocated',
    id: 'total_amount_allocated',
    align: 'left',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>
        {CurrencyUtils.formatCurrency(cellValue ?? 0)}
      </React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Reminded Date',
    id: 'reminded_date',
    align: 'left',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>
        {cellValue ? DatesUtils.formatDate(cellValue) : '-'}
      </React.Fragment>
    ),
    inData: true,
  },
];
